// Shuriken PMO-P — Authentication & RBAC System
// Roles: board > clevel > pmodirector > admin > consultant > analyst > pmostaff

export const ROLES = {
  BOARD:       "board",
  CLEVEL:      "clevel",
  PMODIRECTOR: "pmodirector",
  ADMIN:       "admin",
  CONSULTANT:  "consultant",
  ANALYST:     "analyst",
  PMOSTAFF:    "pmostaff",
  PM:          "pm",
};

export const ROLE_LABELS = {
  board:       "Board Member",
  clevel:      "C-Level Executive",
  pmodirector: "PMO Director",
  admin:       "System Administrator",
  consultant:  "Consultant",
  analyst:     "Analyst",
  pmostaff:    "PMO Staff",
  pm:          "Project Manager",
};

export const ROLE_COLORS = {
  board:       "#C9A84C",  // Gold
  clevel:      "#A78BFA",  // Purple
  pmodirector: "#00D4FF",  // Cyan
  admin:       "#FF6B35",  // Orange
  consultant:  "#00E676",  // Green
  analyst:     "#64B5F6",  // Blue
  pmostaff:    "#8BB8D8",  // Grey-blue
  pm:          "#F472B6",  // Pink
};

export const USERS = [
  {
    username: "hassaan",
    password: "NexGenMa3b00ch",
    role:     "pmodirector",
    name:     "Hassaan Alrifai",
    email:    "hassaan@cybershuriken.com",
    created:  "2026-01-01",
    org:      "Cyber Shuriken Technologies",
  },
  {
    username: "board",
    password: "Board@PMO2026!",
    role:     "board",
    name:     "Board Member",
    email:    "board@cybershuriken.com",
    created:  "2026-01-01",
    org:      "Board of Directors",
  },
  {
    username: "ceo",
    password: "CLevel@PMO2026!",
    role:     "clevel",
    name:     "Chief Executive Officer",
    email:    "ceo@cybershuriken.com",
    created:  "2026-01-01",
    org:      "Executive Leadership",
  },
  {
    username: "admin",
    password: "NexGenMa3b00ch",
    role:     "admin",
    name:     "System Administrator",
    email:    "admin@cybershuriken.com",
    created:  "2026-01-01",
    org:      "IT Operations",
  },
  {
    username: "consultant",
    password: "Consult@PMO2026!",
    role:     "consultant",
    name:     "External Consultant",
    email:    "consultant@cybershuriken.com",
    created:  "2026-01-01",
    org:      "Advisory Services",
  },
  {
    username: "analyst",
    password: "Analyst@PMO2026!",
    role:     "analyst",
    name:     "PMO Analyst",
    email:    "analyst@cybershuriken.com",
    created:  "2026-01-01",
    org:      "PMO Operations",
  },
  {
    username: "pmostaff",
    password: "Staff@PMO2026!",
    role:     "pmostaff",
    name:     "PMO Staff Member",
    email:    "staff@cybershuriken.com",
    created:  "2026-01-01",
    org:      "PMO Operations",
  },
  {
    username: "pm.demo",
    password: "PM@Shuriken2026!",
    role:     "pm",
    name:     "Demo Project Manager",
    email:    "pm@cybershuriken.com",
    created:  "2026-01-01",
    org:      "PMO Operations",
  },
];

// Route access matrix — routes mapped to required minimum role(s)
const ROUTE_ACCESS = {
  "/":              ["board", "clevel", "pmodirector", "admin", "consultant", "analyst", "pmostaff"],
  "/portfolio":     ["board", "clevel", "pmodirector", "admin", "consultant", "analyst", "pmostaff"],
  "/health":        ["clevel", "pmodirector", "admin", "consultant", "analyst", "pmostaff"],
  "/benefits":      ["clevel", "pmodirector", "admin", "consultant", "analyst"],
  "/risk":          ["clevel", "pmodirector", "admin", "consultant", "analyst"],
  "/resources":     ["clevel", "pmodirector", "admin", "consultant", "analyst", "pmostaff"],
  "/financial":     ["clevel", "pmodirector", "admin", "consultant", "analyst"],
  "/schedule":      ["clevel", "pmodirector", "admin", "consultant", "analyst", "pmostaff"],
  "/dependencies":  ["clevel", "pmodirector", "admin", "consultant", "analyst"],
  "/workforce":     ["clevel", "pmodirector", "admin", "consultant"],
  "/rationalization":["clevel", "pmodirector", "admin", "consultant"],
  "/executive":     ["board", "clevel", "pmodirector", "admin"],
  "/ai-agent":      ["clevel", "pmodirector", "admin", "consultant", "analyst"],
  "/platform-map":  ["board", "clevel", "pmodirector", "admin", "consultant", "analyst", "pmostaff"],
  "/registry":      ["board", "clevel", "pmodirector", "admin", "consultant", "analyst", "pm"],
  "/reports":       ["board", "clevel", "pmodirector", "admin", "consultant", "analyst", "pm"],
  "/users":         ["pmodirector", "admin"],
  "/settings":      ["pmodirector", "admin", "clevel"],
};

export function canAccess(role, path) {
  const allowed = ROUTE_ACCESS[path];
  if (!allowed) return false;
  return allowed.includes(role);
}

export function authenticate(username, password) {
  return USERS.find(u => u.username === username && u.password === password) || null;
}

export function getAccessibleRoutes(role) {
  return Object.entries(ROUTE_ACCESS)
    .filter(([, roles]) => roles.includes(role))
    .map(([path]) => path);
}

export function isPrivileged(role) {
  return ["board", "clevel", "pmodirector", "admin"].includes(role);
}
